<template>
  <v-app-bar app color="primary" height="50" fixed>
    <v-app-bar-nav-icon v-if="windowWidth <= 960" variant="text" @click.stop="drawer = !drawer" />
    <v-row class="d-flex justify-center ma-0">
      <v-col md="10" sm="9" cols="6" class="text-left mt-3" align-self="center">
        <img :src="imageLogoPath" style="max-width: 100px" class="ml-5 cursorPointer" @click="router.push({ name: 'home' })" />
      </v-col>
      <v-col md="2" sm="3" cols="6" class="text-right pl-0" align-self="center">
        <v-icon v-show="routerName !== 'producto'" v-if="!store.state.logged " @click="showLoginForm = true">mdi-account</v-icon>
        <v-menu v-else>
          <template v-slot:activator="{ props }">
            <v-icon v-bind="props">mdi-account</v-icon>
          </template>
          <v-list bg-color="white">
            <v-list-item @click="router.push({ name: 'optico' })">
              <v-list-item-title> {{t('myOrders')}} </v-list-item-title>
            </v-list-item>
            <v-list-item @click="logout()">
              <v-list-item-title> Log out </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu>
          <template v-slot:activator="{ props }">
            <v-btn v-bind="props">
              {{ textSelected }}
            </v-btn>
          </template>
          <v-list bg-color="white">
            <v-list-item v-for="entry in languages" :key="entry.title" @click="changeLocale(entry)">
              <v-list-item-title>
                <!-- <CountryFlag :country="entry.flag" class="mr-1" /> -->
                {{ entry.text + "   " + entry.title }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>
  </v-app-bar>
  <v-navigation-drawer v-model="drawer" temporary border color="#414243" mobile-breakpoint="md">
    <v-list class="fMontserrat">
      <v-list-item class="cursorPointer" @click="openUrl('https://indo.es/es/')"> {{t('visit')}} indo.es </v-list-item>
      <v-list-item> {{ t('followUs') }} </v-list-item>
      <v-list-item> 
          <!-- <Icon icon="material-symbols:mail" style="font-size: 20px" @click="openDlgMail()" class="mr-2 cursorPointer" /> -->
          <Icon
            icon="uil:facebook"
            style="font-size: 20px"
            class="mr-2 cursorPointer"
            @click="openUrl('https://www.facebook.com/IndoEspana/?locale=es_ES')" />
          <Icon
            icon="uil:instagram-alt"
            style="font-size: 20px"
            class="mr-2 cursorPointer"
            @click="openUrl('https://www.instagram.com/indo_optical/')" />

          <!-- <Icon
            icon="fa6-brands:square-x-twitter"
            style="font-size: 20px"
            class="mr-2"
            @click="
              openUrl(
                'https://www.linkedin.com/company/indooptical/mycompany/'
              )
            "
          /> -->
          <Icon
            icon="uil:linkedin"
            style="font-size: 20px"
            class="mr-2 cursorPointer"
            @click="openUrl('https://www.linkedin.com/company/indooptical/mycompany/')" />
      </v-list-item>
    </v-list>

    <template v-slot:append>
      <v-list  density="compact">
        <v-list-item style="font-size: 12px;" v-for="(pol, index) in politicas" :key="index" min-height="0">
          <span @click="openUrl(pol.url)">{{ pol.texto }}</span>
        </v-list-item>
      </v-list>
    </template>
  </v-navigation-drawer>
  <v-dialog v-model="showLoginForm" max-width="700px">
    <Login @closeloginform="closeDialog" />
  </v-dialog>
</template>

<script setup>
import store from "./../store";
import router from "./../router";
// import CountryFlag from "vue-country-flag-next";
import { ref, onMounted, onBeforeUnmount, computed } from "vue";
import { t, loadTranslations } from "./../functions/translation.js";
import { Icon } from "@iconify/vue";
import Login from "./LoginComponent.vue";

var routerName = computed(() => router.currentRoute.value.name)
var drawer = ref(false);
const imageLogoPath = require("./../assets/LogoINDO.png");
const showLoginForm = ref(false);

var windowWidth = ref(window.innerWidth);

const handleResize = () => {
  windowWidth.value = window.innerWidth;
};

onMounted(() => {
  window.addEventListener("resize", handleResize);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", handleResize);
});

const politicas = ref([
  { texto: t("privacyPolicy"), url: "https://indo.es/es/privacy" },
  { texto: t("legalWarning"), url: "https://indo.es/es/legal" },
  { texto: "Cookies", url: "https://indo.es/es/cookies" },
//   { texto: t("integratedPolicy"), url: "https://indo.es/docs/politica_integrada_2022.pdf" },
//   { texto: t("complaintSystem"), url: "https://indooptical.integrityline.com/frontpage" },
]);

const languagesBase = [
  { flag: "gb", language: "en", title: "English", text: "EN" },
  { flag: "es", language: "es", title: "Español", text: "ES" },
  { flag: "pt", language: "pt", title: "Português", text: "PT" },
  { flag: "es-ca", language: "es_ct", title: "Català", text: "CA" },
  { flag: "fr", language: "fr", title: "Français", text: "FR" },
];

var languages = languagesBase.filter((item) => item.language !== store.state.locale);
var textSelected = languagesBase.find((item) => item.language === store.state.locale).text;

const changeLocale = async (item) => {
  await loadTranslations(item.language);
  store.state.locale = item.language;
  textSelected = item.text;
  // languageSelected = item.title;
  languages = languagesBase.filter((lang) => lang.language !== store.state.locale);
  localStorage.setItem("locale", item.language);
  location.reload();
};

// const openDlgMail = () => {
//   dlgEmail.value = true;
//   drawer.value = false;
// }

const openUrl = (url) => {
  window.open(url, "_blank");
};

const logout = () => {
  store.state.logged = false;
  store.state.optico = "";
  router.push("/");
};

const closeDialog = (type, url) => {
  showLoginForm.value = false;
  if (type === "optico") {
    router.push({ name: "optico" });
    return;
  }
  if (url === "") console.log("Error");
  const baseUrl = window.location.origin;
  const absoluteUrl = new URL(url, baseUrl).toString();
  router.push(absoluteUrl.replace(baseUrl, ""));
};
</script>

<style scoped>
.fMontserrat {
  font-family: Montserrat;
}
</style>
